//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectEdgeList.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Length",0,"Expression",0],[1,"Radius",0,"Expression",0],[1,"SelectEdge",0,"SelectEdgeList",0],[1,"SelectObject",0,"SelectNXObjectList",0],[1,"VentingClearance",0,"Expression",0],[0,"VentingNumber",1,0],[1,"VentingPitch",0,"Expression",0],[1,"VentingRadius",0,"Expression",0],[0,"VentingType",1,0],[1,"Width",0,"Expression",0],[0,"WizardType",1,0]],[],[]];
SPLM.Tooling.StripperVentingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.StripperVentingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.StripperVentingBuilder.Types = Object.freeze({
    "Create" : "Create", "Edit" : "Edit"});

SPLM.Tooling.StripperVentingBuilder.VentingTypes = Object.freeze({
    "First" : "First", "Second" : "Second"});

export default SPLM;